var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "newsletter",
      class: {
        "is-open": _vm.isOpen,
        "is-sent": _vm.sent,
        "is-loading": _vm.isLoading
      }
    },
    [
      _c("h3", {
        staticClass: "newsletter__title",
        domProps: { innerHTML: _vm._s(_vm.title) },
        on: {
          click: function($event) {
            _vm.isOpen = !_vm.isOpen
          }
        }
      }),
      _vm._v(" "),
      !_vm.sent
        ? _c(
            "form",
            {
              staticClass: "newsletter__form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  _vm.submit()
                }
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email"
                  }
                ],
                ref: "input",
                attrs: {
                  type: "email",
                  required: "",
                  placeholder: _vm.emailLabel
                },
                domProps: { value: _vm.email },
                on: {
                  blur: function($event) {
                    _vm.isOpen = false
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "submit" },
                domProps: { value: _vm.buttonLabel }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.sent && !_vm.error
        ? _c("div", {
            staticClass: "newsletter__message newsletter__message--success",
            domProps: { innerHTML: _vm._s(_vm.successMessage) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sent && _vm.error
        ? _c("div", {
            staticClass: "newsletter__message newsletter__message--error",
            domProps: { innerHTML: _vm._s(_vm.errorMessage) }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }